import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

export const FILTER_SELECT_MIN_WIDTH = 200;
export const FILTER_DATE_MIN_WIDTH = 220;

type FilterFieldProps = {
  children: ReactNode;
  minWidth?: number;
} & BoxProps;

/** Wraps a single filter control with a consistent minimum width so labels and inputs do not collapse. */
export const FilterField = ({
  children,
  minWidth = FILTER_SELECT_MIN_WIDTH,
  sx,
  ...props
}: FilterFieldProps) => (
  <Box
    sx={{
      minWidth,
      width: { xs: '100%', sm: minWidth },
      flex: { xs: '1 1 100%', sm: `0 1 ${minWidth}px` },
      maxWidth: { xs: '100%', sm: 320 },
      ...sx
    }}
    {...props}>
    {children}
  </Box>
);

/** Horizontal filter row that wraps cleanly on smaller viewports. */
export const FilterBar = ({ children, sx, ...props }: BoxProps) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      gap: 2,
      width: '100%',
      ...sx
    }}
    {...props}>
    {children}
  </Box>
);
